import React, { Component } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "./donutChart.css";
import _ from "lodash";

import { colorMapping } from "./config";
import loader from "../../../../../assets/icons/loader.gif";
import { ChartComingSoon } from "../../style";
import { PropTypes } from "prop-types";
import { replaceSelect } from "../../../../../utils/replacer";

export default class DonutChart extends Component {
  state = {
    chartData: ""
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      let finalData = [];

      _.map(this.props.data, item => {
        let obj = {
          x: item[0],
          y: item[1],
          name: item[2]
        };
        finalData.push(obj);
      });
      this.setState({
        chartData: finalData
      });
    }
  }

  render() {
    let chartData = this.props.data.length;
    const chart_config = {
      chart: {
        type: "pie",
        height: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            return 650;
          } else if (windowWidth < 375) {
            return 650;
          } else if (windowWidth >= 375 && windowWidth < 767) {
            return 650;
          }
        })(),
        margin: [100, 0, 0, 0],
        events: {
          load: () => {}
        }
      },
      title: {
        verticalAlign: "top",
        useHTML: true,
        text:
          '<div id="addText">' +
          '<div className="circleBalance">Current Balance</div>' +
          '<div className="circleAmount">' +
          this.props.balance +
          "</div>" +
          "</div>",
        y: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            return -70;
          } else {
            return -110;
          }
        })()
      },
      subtitle: {
        text: ""
      },
      plotOptions: {
        pie: {
          colors: colorMapping(this.state.chartData),
          size: (function() {
            let windowWidth = window.innerWidth;
            if (windowWidth > 767) {
              return 350;
            } else {
              return 320;
            }
          })(),
          center: (function() {
            let windowWidth = window.innerWidth;
            if (windowWidth > 767) {
              return ["50%", "110px"];
            } else {
              return ["49.9%", "110px"];
            }
          })(),
          showInLegend: true
        },
        series: {
          dataLabels: {
            enabled: false
          },
          point: {
            events: {
              legendItemClick: function() {
                return false; // <== returning false will cancel the default action
              }
            }
          }
        }
      },
      legend: {
        itemStyle: {
          fontSize: "18px"
        },
        enabled: true,
        width: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            return 450;
          } else {
            return 350;
          }
        })(),
        maxHeight: 320,
        layout: "horizontal",
        aligin: "center",

        x: (function() {
          let windowWidth = window.innerWidth;
          if (windowWidth > 767) {
            return 40;
          } else if (windowWidth < 375) {
            return 45;
          } else if (windowWidth >= 375 && windowWidth < 767) {
            return 45;
          }
        })(),

        floating: true,
        verticalAlign: "top",
        y: 400,

        itemMarginTop: 10,
        useHTML: true,
        labelFormatter: function() {
          return (
            "<div>" +
            '<div class="chartPercentageText">' +
            this.y.toFixed(2) +
            "%</div>" +
            '<div class="chartText">' +
            replaceSelect(this.name) +
            "</div>" +
            '<div class="chartText">' +
            "$" +
            parseFloat(this.x).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) +
            "</div>" +
            "</div>"
          );
        }
      },
      tooltip: {
        formatter: function() {
          return "<b>" + replaceSelect(this.point.name) + ":</b> " + this.y.toFixed(2) + "%";
        }
      },
      series: [
        {
          name: "Delivered amount",
          innerSize: "60%",
          data: this.state.chartData
        }
      ]
    };
    return (
      <div>
        {this.props.isAccountSummaryLoading === true ? (
          <div>
            <div className="loader-position-chart">
              <div>
                <img src={loader} className="mr-icon" alt="Loader" />
              </div>
            </div>
          </div>
        ) : this.props.data.length != 0 ? (
          <div>
            <div className="donutChartHeader">Asset Mix</div>
            <div id="chartHeight">
              <HighchartsReact highcharts={Highcharts} options={chart_config} />
            </div>
            {this.state.comingSoon && (
              <ChartComingSoon top={this.state.chartY} left={this.state.chartX}>
                Coming Soon...
              </ChartComingSoon>
            )}
          </div>
        ) : this.props.errorMessage !== "" ? (
          <div className="noDataPlacement-chart-error">
            <div>{this.props.errorMessage}</div>
          </div>
        ) : (
          <div className="noDataPlacement-chart">
            <div className="donutChartHeader">Asset Mix</div>
            <div className="">
              <div>
                <img src={loader} alt="Loader" />
                <div className="no-data-text">No data found.</div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
DonutChart.propTypes = {
  data: PropTypes.any,
  isAccountSummaryLoading: PropTypes.bool,
  balance: PropTypes.string
};

